import React from 'react';
// import {LanguageContext} from '../../contexts/LanguageContext'
// import useLanguage from '../../hooks/useLanguage';

import {images} from '../../constants'
import { SubHeading } from '../../components'
import { useNavigate } from 'react-router-dom';
import {motion} from 'framer-motion'
import './Header.css';

const Header = () => {
  let navigate = useNavigate();

  // const {language} = useContext(LanguageContext)
  // const {language} = useLanguage()

  return (
  <div className="app__header app__wrapper section__padding" id="home">
 
    <motion.div initial={{opacity:1}} animate={{x:[0, 100, 0]}} className= "app__wrapper_info">
      <SubHeading title ={"Chase the new flavor"} /> 
      <h1 className="app__header-h1">sweetness on your palate</h1>
      <p className="p__opensans" style={{margin: '2rem 0'}}>Sit tellus lobortis sed senectus vivamus molestie. Condimentum volutpat morbi facilisis quam scelerisque sapien. Et, penatibus aliquam amet tellus </p>
      <button type="button" className="custom__button" onClick={() => navigate('/menu')}>Explore Menu</button>
    </motion.div>

    <div className="app__wrapper_img">
      <motion.img  animate={{rotate:360, transition:{duration:0.5,  bounce: 0.50 ,type:"spring"}}}  src={images.cake} alt="header" />
    </div>
    </div>
    
  
)};

export default Header;
